import { useEffect, useState, useMemo, useContext } from "react";
import "swiper/css";
import "swiper/css/pagination";
import styleColor from "../../assets/kits/colors/colors.module.scss";
import { MinesIcon, TrashIcon, CloseIcon, AddIcon } from "../kits/Icons/Icons";
import { pathMaker } from "../../utilities/helperFunctions";
import "./cart-item.scss";
import "./items.scss";
import Image from "../common/Image";
import CartItemSection from "../common/ProductCard/CartItemSection";
import defaultImg from "../../assets/images/defaultCover/defaultCoverProduct.png";
const Items = ({
  productName,
  price,
  ProductCount,
  changeShoppingCartItemCount,
  shoppingListItemsFinalState,
  inventory,
  min,
  step,
  apo,
  shopId,
  path,
}) => {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    setLoad(false);
  }, [ProductCount]);
  const shoppingListCartState = shoppingListItemsFinalState;
  return (
    <div className="d-flex justify-content-between mr-y-16 items">
      <div className="d-flex">
        <Image
          src={pathMaker(path)}
          placeholderSrc={defaultImg}
          height="48"
          width="48"
          style={{ borderRadius: "6px" }}
        />
        <div className="d-flex flex-column mr-x-8" style={{ height: "45px" }}>
          <a
            href={`/product/${apo.supplier_id}/${apo.product_id}`}
            style={{ textDecoration: "none" }}
            className="mr-b-6"
          >
            <strong
              style={{ color: styleColor.gray_900 }}
              className="title-h5-m title-items text-font-size"
            >
              {productName}
            </strong>
          </a>
          <small
            style={{ color: styleColor.gray_600 }}
            className="text-secondary desc-m text-font-size"
          >
            {price && parseInt(price).toLocaleString()} تومان
          </small>
        </div>
      </div>
      <div>
        {ProductCount && (
          <CartItemSection
            style={{ border: "none" }}
            disabled={false}
            cartItemCount={ProductCount}
            loading={
              shoppingListCartState[`state-${apo.avb_product_for_order__id}`] ==
              true
                ? true
                : false
            }
            plusOnClick={() => {
              setLoad(true);
              changeShoppingCartItemCount(
                "add",
                "",
                inventory,
                min,
                ProductCount,
                step,
                price,
                apo.avb_product_for_order__id,
                productName,
                shopId
              );
            }}
            minusOnClick={() => {
              setLoad(true);
              changeShoppingCartItemCount(
                "reduce",
                "",
                inventory,
                min,
                ProductCount,
                step,
                price,
                apo.avb_product_for_order__id,
                productName,
                shopId
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
export default Items;
